/**
 * @name setMouseStalker
 */
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import { ScrollToPlugin } from "gsap/dist/ScrollToPlugin";

//gsapのプラグインを登録
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);

let mouseLock;
let option = { duration: 0.7, ease: "power4.out", overwrite: true, }
const pointerArea = document.querySelectorAll('[data-pointerArea]');

/**
 * @name setMouseStalker
 * @description マウスストーカーを実装する
 */
export function setMouseStalker() {
  mouseLock = false;
  let stalker, pos, mouse, speed, xSet, ySet, label, arrow;

  //初期設定
  const init = () => {
    stalker = document.querySelector('.stalker');
    label = document.querySelectorAll('.stalker .label');
    arrow = document.querySelectorAll('.stalker .arrow');
    pos = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
    mouse = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
    speed = 0.3;
    xSet = gsap.quickSetter(stalker, "x", "px");
    ySet = gsap.quickSetter(stalker, "y", "px");
  }

  //ポインターの初期設定
  const pointerProcess = (init = false) => {
    mouseLock = false;
    window.addEventListener("mousemove", (event) => {
      mouse.x = event.clientX - (stalker.clientWidth / 2);
      mouse.y = event.clientY - (stalker.clientHeight / 2);
    });
    if (init) {
      gsap.to(stalker, { backgroundColor: "#ca881d66", opacity: 0, scale: 0.1, ...option, });
      gsap.to(label, { color: "#FFFFFF", opacity: 0, ...option, });
      gsap.to(arrow, { opacity: 0, ...option, });
    }
  }

  //ストーカー実装
  const setStalker = () => {
    gsap.ticker.add(() => {
      if (mouseLock === true) {
        return;
      }
      const dt = 1.0 - Math.pow(1.0 - speed, gsap.ticker.deltaRatio());
      pos.x += (mouse.x - pos.x) * dt;
      pos.y += (mouse.y - pos.y) * dt;
      xSet(pos.x);
      ySet(pos.y);
    });
  }

  //ストーカー変化
  const changeStalker = (target) => {
    if (target === null) return;
    let targetPointerArea = target.getAttribute('data-pointerArea');
    let targetPointerLabel = document.getElementById(targetPointerArea);

    const change01 = (x, y) => {
      gsap.to(stalker, { backgroundColor: "#ca881d66", opacity: 1, scale: 1, ...option, });
      gsap.to(targetPointerLabel, { x: x * 25, y: y * 25, color: "#FFFFFF", opacity: 1, ...option, });
    }

    const change02 = (x, y) => {
      gsap.to(stalker, { backgroundColor: "#FFFFFF66", opacity: 1, scale: 1, ...option, });
      gsap.to(targetPointerLabel, { x: x * 25, y: y * 25, color: "#ca881d", opacity: 1, ...option, });
    }

    target.addEventListener("mousemove", (event) => {
      let rect = stalker.getBoundingClientRect();
      let x = (event.clientX - rect.left) / stalker.clientWidth * 2 - 1;
      let y = (event.clientY - rect.top) / stalker.clientHeight * 2 - 1;

      targetPointerArea === "view-all" && change01(x, y);
      targetPointerArea === "click-or-drag" && change02(x, y);
      targetPointerArea === "contact" && change01(x, y);
      targetPointerArea === "tel" && change01(x, y);
      targetPointerArea === "arrow-left" && change01(x, y);
      targetPointerArea === "arrow-right" && change01(x, y);

      if(event.target.classList.contains('isSelect')) {
        pointerProcess(true);
      }
    });
  }

  //初期化
  window.addEventListener("load", () => {
    init();
    pointerProcess(true);
    setStalker();
  })

  //ポインターエリアに入った時
  pointerArea.forEach((element) => {
    element.addEventListener("mouseenter", (event) => changeStalker(event.target));
    element.addEventListener("mouseleave", () => pointerProcess(true));
  });
}